import type { ColumnDef } from '@tanstack/vue-table'
import { RefundRequestEmbed } from '../tables/RefundRequests'

// This type is used to define the shape of our data.
// You can use a Zod schema here if you want.
export const refundRequestsColumns: ColumnDef<RefundRequestEmbed.ListItem>[] = [
  // {
  //   accessorKey: 'id',
  // },
  {
    accessorKey: 'connectedAccount.businessName',
  },
  {
    accessorKey: 'customer.name',
  },
  {
    accessorKey: 'customer.email',
  },
  {
    accessorKey: 'connectedAccount.name',
  },
  {
    accessorKey: 'toBankAccountNumber',
  },
  {
    accessorKey: 'payoutReason',
  },
  {
    accessorKey: 'amount',
    size: 100,
  },
  {
    accessorKey: 'insertTime',
    size: 150,
  },
  {
    accessorKey: 'isAccepted',
  },
  {
    id: 'actions',
    meta: {
      placement: 'end',
    },
    // size: 75,
    // cell: ({ row, emits }) => {
    //   return h(PayoutListOptions, {
    //     payout: row.original,
    //     'onUpdate:close': emits.reload,
    //   })
    // },
  },
]
